import React, { forwardRef } from "react";
import { Switch } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const SwitchBlue = withStyles(theme => ({
	root: {
		width: 44,
		height: 20,
		padding: 0,
		margin: theme.spacing(1)
	},
	switchBase: {
		padding: 1,
		"&$checked": {
			transform: "translateX(22px)",
			color: theme.palette.common.white,
			"& + $track": {
				backgroundColor: theme.palette.primary.main,
				opacity: 1,
				border: "none"
			}
		},
		"&$focusVisible $thumb": {
			color: theme.palette.common.white,
			border: `6px solid ${theme.palette.common.white}`
		}
	},
	thumb: {
		width: 20,
		height: 18
	},
	track: {
		borderRadius: 20 / 2,
		backgroundColor: theme.palette.info.contrastText,
		opacity: 1,
		transition: theme.transitions.create(["background-color", "border"])
	},
	checked: {},
	focusVisible: {}
}))(
	forwardRef(({ classes, ...props }) => {
		return (
			<Switch
				focusVisibleClassName={classes.focusVisible}
				disableRipple
				classes={{
					root: classes.root,
					switchBase: classes.switchBase,
					thumb: classes.thumb,
					track: classes.track,
					checked: classes.checked
				}}
				{...props}
			/>
		);
	})
);

export default SwitchBlue;
